import {GET, POST} from '../http';

export const GetHotelParameters = spec=>{
    return GET("Organization/Hotel/GetHotelParameters",spec)
}

export const GetUser = spec=>{
    return GET("Organization/User/GetUser",spec)
}

export const GetUserParams = () => {
    return GET("Organization/User/GetUserParams")
}

export const GetHotels = spec=>{
    return GET("Organization/HotelDataService/GetHotels",spec)
}

export const UpdateUser  = spec=>{
    return POST("Organization/User/UpdateUser", spec)
}

export const GetUsers = spec=>{
    return GET("Organization/User/GetUsers",spec)
}
export const GetSystemAdminUsers = spec=>{
    return GET("Organization/User/GetSystemAdminUsers",spec)
}

export const GetWings = spec=>{
    return GET("Organization/WingDataService/GetWings",spec)
}

export const UpdatePassword = spec=>{
    return POST("Organization/Account/UpdatePassword", spec)
}

